import { useApi } from '../hooks/useApi.js'
import { apiGet } from '../lib/api.js'
import RailBlock from '../components/RailBlock.jsx'

const getStats = () => apiGet('/stats/')

function StatsPage() {
  const { data, loading } = useApi(getStats)

  const stats = data || {}

  const statItems = [
    { value: stats.qa_seeded || 0, label: 'QA SEEDED' },
    { value: stats.qa_goal || 500, label: 'QA GOAL' },
    { value: stats.embedding_dims || 384, label: 'EMBEDDING DIMS' },
    { value: stats.vector_indexes || 8, label: 'VECTOR INDEXES' },
  ]

  const metaItems = [
    { key: 'Stack', value: 'Django · React · Neo4j · Tailwind' },
    { key: 'Hosting', value: 'EC2 · S3 · CloudFront' },
    { key: 'Build', value: 'Vite · uv · GitHub Actions' },
    { key: 'Terminal', value: (<kbd className="font-mono text-xs px-1.5 py-0.5 bg-soft-surface border border-soft-rule rounded">⌘ + I</kbd>) },
  ]

  return (
    <div className="pg-layout">
      {/* LEFT */}
      <div>
        <p className="font-mono text-[11px] uppercase tracking-[0.6px] text-soft-faint mb-3">
          YOU FOUND IT.
        </p>
        <h1 className="text-[32px] sm:text-[40px] md:text-[48px] font-normal leading-[1.05] tracking-[-1.4px] mb-4">
          What this site is, by the numbers.
        </h1>
        <p className="text-[17px] leading-[1.5] text-soft-dim mb-10 max-w-[640px]">
          Not linked from anywhere. You clicked the dot in the footer, or you guessed the URL.
          Either way: welcome.
        </p>

        {/* Stat band */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-9 py-8 border-t border-b border-soft-rule mb-10">
          {statItems.map((item) => (
            <div key={item.label}>
              <p className="text-[44px] font-normal leading-[1] tracking-[-1.4px] text-soft-ink mb-2">
                {loading ? '-' : item.value}
              </p>
              <p className="font-mono text-[11px] uppercase tracking-[0.6px] text-soft-faint">
                {item.label}
              </p>
            </div>
          ))}
        </div>

        {/* Meta grid */}
        <div className="grid grid-cols-1 sm:grid-cols-[140px_1fr] gap-y-4 gap-x-8">
          {metaItems.map((item) => (
            <div key={item.key} className="contents">
              <span className="text-sm text-soft-faint">{item.key}</span>
              <span className="text-sm text-soft-ink">{item.value}</span>
            </div>
          ))}
        </div>
      </div>

      {/* RIGHT rail */}
      <aside>
        <RailBlock eyebrow="Live now" top>
          <div className="flex items-center gap-2 mb-2">
            <span className="w-2 h-2 bg-[#9dbf9f] animate-pulse" />
            <span className="text-[13.5px] text-soft-ink">Healthy · 47/47 processes</span>
          </div>
          <p className="font-mono text-[11px] text-soft-faint">UPTIME · 99.9%</p>
        </RailBlock>

        <RailBlock eyebrow="Endpoints">
          <div className="divide-y divide-soft-rule">
            {[
              { path: '/api/agent/', note: 'streaming · ollama' },
              { path: '/api/stats/', note: 'json · cached 60s' },
              { path: '/api/consent/', note: 'post · sqlite' },
              { path: '/api/health/', note: 'get · always 200' },
            ].map((ep) => (
              <div key={ep.path} className="flex justify-between items-center py-2.5">
                <span className="font-mono text-[11px] text-soft-faint">{ep.path}</span>
                <span className="font-mono text-[11px] text-soft-dim">{ep.note}</span>
              </div>
            ))}
          </div>
        </RailBlock>

        <RailBlock eyebrow="Source">
          <p className="text-[13.5px] text-soft-ink mb-1">Open source on GitHub</p>
          <a
            href="https://github.com/tabspacecoder/aboutmecosmic"
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono text-[11px] text-soft-faint hover:text-soft-dim transition-colors"
          >
            github.com/tabspacecoder/aboutmecosmic →
          </a>
        </RailBlock>
      </aside>
    </div>
  )
}

export default StatsPage
